import parse from 'html-react-parser';

export function getParsedHTML(value: string) {
  return <div style={{ whiteSpace: 'normal' }}>{parse(value)}</div>
}
